import { FormMessage, FormMessageVariant } from '@aus-platform/design-system';

export const TerrainCleanupGuide: React.FC = () => {
  return (
    <div className="guide-page map-3d-sidebar-content terrain-cleanup-guide">
      <ul>
        <li>
          <span>Step 1 - </span>
          <p>
            Go to <strong>Generate</strong> tab.
          </p>
        </li>
        <li>
          <span>Step 2 - </span>
          <p>Input the cleanup name.</p>
        </li>
        <li>
          <span>Step 3 - </span>
          <p>
            Choose the <strong>Area of Interest</strong> by selecting Draw or
            Layer from Workspace, and provide one or more polygons.
          </p>
        </li>
        <li>
          <span>Step 4 - </span>
          <p className="terrain-cleanup-guide__last-step">
            Click <strong>Generate Cleanup</strong> to submit the request. Each
            successful cleanup is <strong>auto-set as Active Terrain</strong>,
            limited to <strong>one</strong> active at a time.
          </p>
        </li>
      </ul>
      <FormMessage
        className="terrain-cleanup-guide__info"
        variant={FormMessageVariant.Info}
        message={
          <>
            <h4 className="terrain-cleanup-guide__info__title">Note:</h4>
            <div className="terrain-cleanup-guide__info__description">
              <ul>
                <li>
                  Applying a cleanup updates the terrain for the selected
                  iteration <strong>across organisation</strong>. Any workspaces
                  using that iteration will also be updated.
                </li>
                <li>
                  Deleting the uploaded DEM <strong>deletes</strong> all its
                  cleanups and resets the active terrain.
                </li>
              </ul>
            </div>
          </>
        }
      />
    </div>
  );
};
